<template>
  <div class="w-[calc(100%-75px)] h-[calc(100%-100px)] absolute transition-all z-998 top-100px">
    <div
      class="flex items-center justify-center absolute single-close w-24px h-24px z-999 cursor-pointer rounded-[50%]"
      @click.stop="removeTag(componentList[0])"
    >
      <span class="text-12px iconfont icon-line-close text-[#34b9f2]"></span>
    </div>
    <div class="h-full w-full">
      <keep-alive :include="keepAliveComponents">
        <component
          v-if="activeComponent && componentList.length"
          :is="activeComponent"
          :player="player"
          :currentComponent="activeComponent"
          :transferProps="transferProps[activeComponent]"
          :customProps="customProps"
          :cloudRender="cloudRender"
          :labelList="labelList"
          :sourceId="sourceId"
          @transferEvent="transferEvent"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import exportComponents from '../../assets/js/exports/exportsComponents'
import { UNALLOW_COEXIST_COM } from '../../assets/js/model/basicCode'

export default {
  components: {
    ...exportComponents,
  },
  name: 'ComponentContainer',
  props: {
    baseProps: {
      type: Object,
      defalut: () => {
        return {
          location: 'left',
          // 当前激活组件
          currentComponent: {},
          // 最大共存数
          coexistenceNum: 1,
        }
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    // 云渲染实例
    player: {
      type: Object,
      defalut: null,
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 通知关闭的组件
    noticeCloseComponent: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 通知关闭的标签
    noticeCloseLabel: {
      type: Array,
      defalut: () => {
        return []
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      componentList: [],
      activeComponent: '',
      activeName: '',
    }
  },
  computed: {
    keepAliveComponents() {
      const clipComs = ['AllClip', 'PartClipBox', 'ThreePanel']
      return _.map(this.componentList, (item) => {
        if (clipComs.includes(item.code)) {
          return 'ClipTool'
        }
        return item.code
      }).join(',')
    },
  },
  watch: {
    noticeCloseComponent: {
      handler(data) {
        if (data.code) {
          const filterComponent = _.filter(this.componentList, (item) => {
            return item.origin === data.code || item.code === data.code
          })
          _.forEach(filterComponent, (item) => {
            this.removeTag(item)
          })
        }
      },
      deep: true,
    },
    noticeCloseLabel: {
      handler(closeList) {
        const filterComponent = _.filter(this.componentList, (item) => {
          return (
            item.origin === 'tag' &&
            _.some(closeList, (label) => {
              return item.originTagName === label.code
            })
          )
        })
        _.forEach(filterComponent, (item) => {
          this.removeTag(item)
        })
      },
      deep: true,
    },
    'baseProps.currentComponent': {
      handler(data) {
        if (data.code) {
          const findComponentIndex = _.findIndex(this.componentList, (item) => {
            return item.code === data.code
          })
          if (
            findComponentIndex !== -1 &&
            data.origin !== this.componentList[findComponentIndex].origin
          ) {
            this.componentList.splice(findComponentIndex, 1, data)
          } else if (findComponentIndex === -1) {
            // 是否存在互斥组件，如果有则关闭
            const mutexIndex = _.findIndex(this.componentList, (item) => {
              return (
                UNALLOW_COEXIST_COM[data.code] && UNALLOW_COEXIST_COM[data.code].includes(item.code)
              )
            })
            if (mutexIndex !== -1) {
              this.$emit('closeComponent', this.componentList[mutexIndex], false)
              this.componentList.splice(mutexIndex, 1)
            }
            // 只能放单个组件的情况
            if (this.baseProps.coexistenceNum <= 1 && !_.isEmpty(this.componentList)) {
              this.$emit('closeComponent', this.componentList[0], false)
              this.componentList = []
            }
            this.componentList.push(data)
          }

          this.changeActive(data)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 组件内部传递出来的事件
    transferEvent(data) {
      if (data.type === 'close') {
        this.$emit('closeComponent', data.toCom, _.isEmpty(this.componentList))
      }
      this.$emit('transferEvent', data)
    },
    // 切换组件显示
    changeActive(tag) {
      this.activeComponent = tag.code
      this.activeName = tag.name
      this.$emit('selectTab', tag.code)
    },
    // 关闭组件显示
    removeTag(tag) {
      if (tag) {
        const tagIndex = _.findIndex(this.componentList, ['code', tag.code])
        this.componentList.splice(tagIndex, 1)
        if (this.activeComponent === tag.code) {
          this.changeActive(_.isEmpty(this.componentList) ? {} : _.last(this.componentList))
        }
        this.$emit('closeComponent', tag, _.isEmpty(this.componentList))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.single-close {
  background: linear-gradient(146.24deg, #114e67 0%, #0a364d 100%),
    radial-gradient(circle at 50% 50%, #59c8fc 0%, #52ace500 100%);
  border: 1px solid #34b9f2;
  top: var(--containerSingleCloseTop);
  right: var(--containerSingleCloseRight);
}
</style>
